import { useRef } from 'react';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import { feature1, feature2, feature3, feature4 } from "../../helper/utils";
import "./feature-services.css"
import { ReactComponent as LogoSmall } from "../../assets/icons/LogoSmall.svg"

const FeatureServices = () => {
    // Refs for Row 1
    const img1Ref = useRef(null);
    const text1Ref = useRef(null);
    const img2Ref = useRef(null); // Mobile image if separate

    // Refs for Row Extra
    const textExtraRef = useRef(null);
    const imgExtraRef = useRef(null);

    // Refs for Row 2
    const text2Ref = useRef(null);
    const img3Ref = useRef(null);

    // Refs for Row 3 / Flex Div
    const extraCutRef = useRef(null);
    const alterImgRef = useRef(null);
    const text3Ref = useRef(null);

    useScrollAnimation([
        img1Ref, text1Ref, img2Ref,
        textExtraRef, imgExtraRef,
        text2Ref, img3Ref,
        extraCutRef, alterImgRef, text3Ref
    ]);

    return (
        <div className='services-card-main'>
            <div className="feature-row-1">
                <div ref={img1Ref} className="flex-class animate-on-scroll">
                    <img src={feature1} className="feature-image" alt="Bespoke Tailoring Process" />
                </div>
                <div ref={text1Ref} className="box-blog-main animate-on-scroll">

                    <div className="box-blog-one logo-display">
                        <LogoSmall />
                    </div>

                    <div className="box-blog-two">
                        <p className="box-blog-huge-text">1</p>

                        <div className="box-absolute-div">

                            <div className="line-gap">
                                <p className="box-blog-text-one">Bespoke Tailoring</p>
                                <div className="line-separator-golden"></div>
                            </div>
                            <div>
                                <p className="box-blog-text-two">Experience the luxury of custom-made clothing, crafted to your exact specifications</p>
                            </div>

                        </div>
                    </div>


                </div>
                <div ref={img2Ref} className="flex-class feature-none animate-on-scroll">
                    <img src={feature2} className="feature-image" alt="Custom Design Sketching" />
                </div>

            </div>

            <div className="feature-row-extra">


                <div ref={textExtraRef} className="box-blog-main feature-extra-display animate-on-scroll">

                    <div className="box-blog-two">
                        <p className="box-blog-huge-text">2</p>

                        <div className="box-absolute-div">

                            <div className="line-gap">
                                <p className="box-blog-text-one">Custom Designs</p>
                                <div className="line-separator-golden"></div>
                            </div>
                            <div>
                                <p className="box-blog-text-two">Bring your fashion vision to life with our expert design services.</p>
                            </div>

                        </div>
                    </div>

                    <div className="box-blog-one alter-image-none">
                        <div>
                            <p className="feature-subtitle">Cut for the Gentlemen</p>
                            <div className="feature-line-separator"></div>
                        </div>
                    </div>


                </div>

                <div ref={imgExtraRef} className="flex-class feature-extra-display mobile-none animate-on-scroll">
                    <img src={feature2} className="feature-image" alt="Custom Design Sketching" />
                </div>
            </div>

            <div className="feature-row-2">
                <div ref={text2Ref} className="box-blog-main feature-none animate-on-scroll">

                    <div className="box-blog-two">
                        <p className="box-blog-huge-text">2</p>

                        <div className="box-absolute-div">

                            <div className="line-gap">
                                <p className="box-blog-text-one">Custom Designs</p>
                                <div className="line-separator-golden"></div>
                            </div>
                            <div>
                                <p className="box-blog-text-two">Bring your fashion vision to life with our expert design services.</p>
                            </div>

                        </div>
                    </div>

                    <div className="box-blog-one">
                        <div>
                            <p className="feature-subtitle">Cut for the Gentlemen</p>
                            <div className="feature-line-separator"></div>
                        </div>
                    </div>


                </div>

                <div ref={img3Ref} className="flex-class animate-on-scroll">
                    <img src={feature3} className="feature-image" alt="Gentleman's Suit Cut" />
                </div>

                <div className="flex-div">

                    <div ref={extraCutRef} className="extra-cut-main-div animate-on-scroll">
                        <div className="flex-class extra-cut-div">
                            <img src={feature2} className="feature-small-image" alt="Alterations and Repairs" />
                        </div>
                        <div className="box-blog-one extra-cut-div padding-extra" >
                            <div>
                                <p className="feature-subtitle">Cut for the Gentlemen</p>
                                <div className="feature-line-separator"></div>
                            </div>
                        </div>
                    </div>

                    <div ref={alterImgRef} className="flex-class alter-image-none animate-on-scroll">
                        <img src={feature4} className="feature-small-image" alt="Alterations and Repairs" />
                    </div>

                    <div ref={text3Ref} className="box-blog-two animate-on-scroll">
                        <p className="box-blog-huge-text">3</p>

                        <div className="box-absolute-div">

                            <div className="line-gap">
                                <p className="box-blog-text-one">Corporate Dress Tailor</p>
                                <div className="line-separator-golden"></div>
                            </div>
                            <div>
                                <p className="box-blog-text-two">Professional tailoring services for corporate clients, ensuring a perfect fit and impeccable finish for business attire.</p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeatureServices;
